import { unwrapResult } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

import {
    ComponentHeaderAuth,
    ComponentSocialMedia,
    StyledContainerAuthSignUp,
    StyledContainerSignIn,
} from "@components";
import {
    enumExternalAuthType,
    enumExternalMethod,
    FACEBOOK_INFO_URL,
    PATH_HOME,
    PATH_SIGN_UP_FORM,
    PATH_WELCOME,
} from "@configs";
import { IExternalAuthState, IFBLogin, IFBSignup } from "@interfaces";
import liff from "@line/liff";
import { ModuleLine, ModuleLineTelSignUp, ModuleTelSignUp } from "@modules";
import {
    addConfigClient,
    fbLogin,
    fbSignup,
    resetAuthState,
    selectAuth,
    selectConfigClient,
    selectMerchant,
    setConfigClient,
} from "@redux";
import { formatMessage, useNotify } from "@utils";
import axios from "axios";

const varAccessToken = "access_token";

export const PageSignUp = () => {
    //page hook
    const { t } = useTranslation();
    const history = useHistory();
    const { error, success } = useNotify();
    const dispatch = useDispatch();
    const { hash } = useLocation();
    const configClient = useSelector(selectConfigClient);
    const { _id } = useSelector(selectMerchant);
    const [checkSuccess, setCheckSuccess] = useState<boolean>(false);

    //redux states
    const merchant = useSelector(selectMerchant);
    const { themes } = useSelector(selectMerchant);
    const { isSignUp, externalLogin } = useSelector(selectAuth);
    //page variable
    const state: IExternalAuthState = {
        type: enumExternalAuthType.SIGNUP,
    };
    const signUpMethod = merchant?.signUpSettings?.signUpMethod;

    useEffect(() => {
        if (hash && hash.includes(varAccessToken)) {
            const hashObj = hash.split("&").reduce((res: any, item) => {
                const parts = item.split("=");
                res[parts[0]] = parts[1];
                return res;
            }, {});
            const accessToken = hashObj?.access_token || undefined;
            if (accessToken) {
                callbackGetFbInfo(accessToken);
            }
        }
        if (
            externalLogin === enumExternalMethod.LINE ||
            externalLogin === enumExternalMethod.LINEOA_TEL
        ) {
            if (sessionStorage.getItem("DISABLE_APP_ROUTE") !== "true") {
                history.push(PATH_WELCOME);
            }
        }
    }, []);
    useEffect(() => {
        const unloadHandler = (event: Event) => {
            dispatch(resetAuthState());
            localStorage.clear();
            sessionStorage.clear();
        };
        if (externalLogin === enumExternalMethod.LINEOA_TEL) {
            window.addEventListener("unload", unloadHandler);
            if (liff.isInClient()) {
                liff._addListener("unload", unloadHandler);
            }
        }

        return () => {
            if (externalLogin === enumExternalMethod.LINEOA_TEL) {
                window.removeEventListener("unload", unloadHandler);
                if (liff.isInClient()) {
                    liff._removeListener("unload", unloadHandler);
                }
            }
        };
    }, []);

    const callbackGetFbInfo = async (accessToken: string) => {
        const url = `${FACEBOOK_INFO_URL}&access_token=${accessToken}`;
        try {
            const res = await axios.get(url);
            if (res.data) {
                let response;
                if (!isSignUp) {
                    const fbLoginData: IFBLogin = {
                        userId: res.data?.id,
                        token: accessToken,
                    };

                    response = await dispatch(fbLogin(fbLoginData));
                    setCheckSuccess(true);
                    success(t("page.login_successfully"));
                    //WHAT: wrap function in create async thunk
                    //@ts-ignore
                    unwrapResult(response);
                } else {
                    const fbSignupData: IFBSignup = {
                        userId: res.data?.id,
                        token: accessToken,
                    };
                    response = await dispatch(fbSignup(fbSignupData));
                    //WHAT: wrap function in create async thunk
                    //@ts-ignore
                    unwrapResult(response);
                }
                //@ts-ignore
                if (!response?.payload.accessToken) {
                    error(t("page.email_password_correct"));
                } else {
                    //@ts-ignore
                    const authData = response.payload;
                    const index = configClient.findIndex((item) => item.merchantId === _id);
                    if (index >= 1) {
                        dispatch(
                            setConfigClient({
                                index,
                                configClient: {
                                    merchantId: _id || "",
                                    token: authData,
                                },
                            })
                        );
                    } else {
                        dispatch(
                            addConfigClient({
                                merchantId: _id || "",
                                token: authData,
                            })
                        );
                    }
                    !isSignUp ? history.push(PATH_HOME) : history.push(PATH_SIGN_UP_FORM);
                }
            } else {
                error(t("message.sign_failed"));
            }
        } catch (err: any) {
            if (err.response) {
                error(formatMessage(err.response));
            } else error(t("message.sign_failed"));
        }
    };

    return (
        <StyledContainerSignIn color={themes?.themeColor!}>
            <ComponentHeaderAuth>
                <>
                    <StyledContainerAuthSignUp bg_color={themes?.themeColor!}>
                        <div className="login-signup">{t("page.login_sign_up")}</div>
                        <div className="logo-image">
                            {<img src={merchant?.themes?.logoSmallUrl} />}
                        </div>
                        <div className="title_auth text-sub-header">
                            {merchant?.name ? merchant?.name : ""}
                        </div>
                        {externalLogin === enumExternalMethod.LINEOA_TEL ? (
                            <ModuleLineTelSignUp />
                        ) : (
                            <>
                                {signUpMethod === enumExternalMethod.LINE && (
                                    <ComponentSocialMedia
                                        socials={[<ModuleLine state={state} />]}
                                    />
                                )}
                                {signUpMethod === enumExternalMethod.LINEOA_TEL && (
                                    <ComponentSocialMedia
                                        socials={[<ModuleLine state={state} />]}
                                    />
                                )}
                                {signUpMethod === enumExternalMethod.TEL && <ModuleTelSignUp />}
                            </>
                        )}
                    </StyledContainerAuthSignUp>
                </>
            </ComponentHeaderAuth>
        </StyledContainerSignIn>
    );
};
